/**
 * Enable toggling of radioboxes within a group.
 *
 * Check `radiobox.scss` and class `.vm-radiobox-group` for more details.
 */
export default function enableRadioboxGroupToggle() {
    document.querySelectorAll('.vm-radiobox-group').forEach((group) => {
        const triggerElement = group.querySelector('.vm-radiobox-group__trigger');

        if (!triggerElement) {
            return;
        }

        triggerElement.addEventListener('click', (ev) => {
            ev.preventDefault();
            group.setAttribute('data-state', group.getAttribute('data-state') === 'open' ? 'closed' : 'open');
        });
    });
}
